import React from 'react';
import { FlatList, TouchableOpacity } from 'react-native';
import { keyExtractor } from 'src/common/utils/KeyExtractor';
import { Container, RegularText } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';
import styled from 'styled-components/native';

// interface ItemProps extends TouchableOpacityProps {
//   active: boolean;
// }

const Styled = {
  ItemWrapper: styled(TouchableOpacity).attrs(() => ({
    activeOpacity: 0.8,
  }))`
    border-radius: ${metrics.borderRadius}px;
    padding-right: ${metrics.large}px;
    margin-right: ${metrics.large}px;
  `,
};

interface Props {
  tabs: string[];
  renderBody: (index: number) => JSX.Element | null;
  value: number;
  onChange: (index: number) => void;
}

export const TabBar = ({ tabs, renderBody, value, onChange }: Props) => {
  const flatListRef = React.useRef<FlatList>(null);

  const renderItem = ({ item, index }: { item: string; index: number }) => {
    return (
      <TabItem
        item={item}
        active={value === index}
        onChange={() => {
          onChange(index);
          flatListRef.current?.scrollToIndex({ index });
        }}
      />
    );
  };
  return (
    <Container flex>
      <Container height={pixelScaler(34)}>
        <FlatList
          ref={flatListRef}
          data={tabs}
          horizontal
          contentContainerStyle={{ paddingHorizontal: metrics.large }}
          showsHorizontalScrollIndicator={false}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          style={{
            borderColor: 'white',
            borderBottomColor: AppColors.border,
            borderWidth: 1,
          }}
        />
      </Container>
      {renderBody(value)}
      {/* {isLoading && <ActivityIndicator animating />} */}
    </Container>
  );
};

const TabItem: React.FC<{ item: string; active: boolean; onChange: () => void }> = ({ item, active, onChange }) => {
  return (
    <Styled.ItemWrapper onPress={onChange}>
      <Container height={pixelScaler(30)}>
        <RegularText fontWeight="bold" color={active ? AppColors.black : AppColors.gray} textLang={item} />
      </Container>
      {active && (
        <Container borderRadius={4} height={pixelScaler(2)} width="100%" backgroundColor={AppColors.primary} />
      )}
    </Styled.ItemWrapper>
  );
};
